import { z } from 'zod';
/** Every language a screen or email of this repository can be in. */
export const localeSchema = z.enum(['fr', 'nl', 'en']);
/** The partner portal and partner emails: French first (the current partners), Dutch too. */
export const portalLocaleSchema = z.enum(['fr', 'nl']);
export const PORTAL_LOCALES = portalLocaleSchema.options;
export const DEFAULT_PORTAL_LOCALE = 'fr';
/** The admin app (Wally staff). */
export const adminLocaleSchema = z.enum(['nl', 'en']);
